module Shared {
    /**
     * Originally from http://plnkr.co/edit/YyO1dQpFDnzSTLqaOllc?p=preview
     * The related issue: https://github.com/minhur/bootstrap-toggle/issues/19
     */
    export function toggleCheckBox() {
        return {
            restrict: 'A',
            replace: false,
            require: 'ngModel',
            link($scope, $element, $attr, ngModel) {

                // update model from Element
                var updateModelFromElement = () => {
                    // If modified
                    var checked = $element.prop('checked');
                    if (checked !== ngModel.$viewValue) {
                        // Update ngModel
                        ngModel.$setViewValue(checked);
                        $scope.$apply();
                    }
                };

                // Update input from Model
                var updateElementFromModel = newValue => {
                    $element.trigger('change');
                };

                // Observe: Element changes affect Model
                $element.on('change',() => {
                    updateModelFromElement();
                });

                $scope.$watch(() => ngModel.$viewValue, newValue => {
                    updateElementFromModel(newValue);
                }, true);

                // Initialise BootstrapToggle
                $element.bootstrapToggle();
            }
        };
    }

    frendsUtilsApp.directive("toggleCheckbox", [toggleCheckBox]);
}